import Swiper from "swiper/bundle";
import { Grid } from "swiper/modules";
import "swiper/css/bundle";
import "swiper/css/grid";

const swiperBanner = new Swiper(".banner-swiper, .testimonials__swiper", {
  slidesPerView: 1,
  speed: 1000,
  effect: "fade",
  fadeEffect: {
    crossFade: true,
  },
  autoplay: {
    delay: 20000,
  },
  navigation: {
    nextEl:
      ".banner-swiper .swiper-button-next, .testimonials__swiper .swiper-button-next",
    prevEl:
      ".banner-swiper .swiper-button-prev, .testimonials__swiper .swiper-button-prev",
  },
});

const swiperCards = new Swiper(
  ".slide-cards__swiper, .slide-cards__swiper--3",
  {
    slidesPerView: 1.3,
    autoplay: {
      delay: 20000,
    },
    centeredSlides: true,
    initialSlide: 3,
    loop: true,
    breakpoints: {
      1200: {
        slidesPerView: 3,
      },
      768: {
        slidesPerView: 2,
      },
    },
    navigation: {
      nextEl:
        ".slide-cards__swiper .swiper-button-next, .slide-cards__swiper--3 .swiper-button-next",
      prevEl:
        ".slide-cards__swiper .swiper-button-prev, .slide-cards__swiper--3 .swiper-button-prev",
    },
  }
);
const swiperCardsRelated = new Swiper(".slide-cards__swiper--related", {
  slidesPerView: 1.3,
  spaceBetween: 30,
  autoplay: {
    delay: 20000,
  },

  initialSlide: 3,
  breakpoints: {
    1200: {
      slidesPerView: 3,
    },
    768: {
      slidesPerView: 2,
    },
  },
  navigation: {
    nextEl: ".slide-cards__swiper--related .swiper-button-next",
    prevEl: ".slide-cards__swiper--related .swiper-button-prev",
  },
});
const swiperCardsTwo = new Swiper(
  ".slide-cards-two__swiper , .slide-cards-three__swiper",
  {
    slidesPerView: 1,
    spaceBetween: 24,
    breakpoints: {
      1200: {
        slidesPerView: 4,
      },
      768: {
        slidesPerView: 3,
      },
      425: {
        slidesPerView: 2,
      },
    },
    navigation: {
      nextEl:
        ".slide-cards-two__swiper .swiper-button-next, .slide-cards-three__swiper .swiper-button-next",
      prevEl:
        ".slide-cards-two__swiper .swiper-button-prev, .slide-cards-three__swiper .swiper-button-prev",
    },
    pagination: {
      el: ".swiper-pagination",
    },
  }
);

const gridProductsSwiper = document.querySelector(".grid-products__swiper");
if (gridProductsSwiper) {
  const columnsDesktop = parseInt(gridProductsSwiper.dataset.columns) || 3;
  const columnsMobile = parseInt(gridProductsSwiper.dataset.columnsMobile) || 1;
  const rowsDesktop = parseInt(gridProductsSwiper.dataset.rows) || 2;
  const rowsMobile = parseInt(gridProductsSwiper.dataset.rowsMobile) || 2;

  const gridProductsSwiperInstance = new Swiper(".grid-products__swiper", {
    modules: [Grid], // Especificamos el módulo Grid
    slidesPerView: columnsMobile,
    spaceBetween: 20,
    grid: {
      rows: rowsMobile,
      fill: "row",
    },
    loop: false,
    autoplay: false,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
      dynamicBullets: true,
    },
    navigation: {
      nextEl: ".grid-products__swiper .swiper-button-next",
      prevEl: ".grid-products__swiper .swiper-button-prev",
    },
    breakpoints: {
      768: {
        slidesPerView: columnsDesktop,
        spaceBetween: 20,
        grid: {
          rows: rowsDesktop,
          fill: "row",
        },
      },
    },
  });
}

const swiper = new Swiper(".mySwiper", {
  loop: true,
  spaceBetween: 10,
  slidesPerView: 5,
  freeMode: true,
  watchSlidesProgress: true,
});
const swiper2 = new Swiper(".mySwiper2", {
  loop: true,
  spaceBetween: 10,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  thumbs: {
    swiper: swiper,
  },
});
